module.exports = __webpack_public_path__ + "img/fix.8a4c1f9a.svg";